import React, { Fragment, useEffect, useState } from "react";
import MainLogo from "./MainLogo";
import "./Navbar.css";

const navbarItems = ["About", "Work", "Contact"];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.onscroll = function () {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
  }, []);

  const handleScrollView = (id) => {
    let element = document.getElementById(id);
    element.scrollIntoView({
      block: "center",
      behavior: "smooth",
    });
  };
  return (
    <Fragment>
      <div
        className={`mainHeader ${scrolled ? "scrolledNavBar" : ""}`}
        id="Header"
      >
        <div className="mainLogo navBarItems">
          <MainLogo height={32} width={32} />
          <span style={{ marginLeft: "1rem", fontSize: "1rem" }}>
            Gaurav Sachar
          </span>
        </div>
        <div className="navBarItems hideOn">
          {navbarItems.map((item, i) => (
            <div
              className="itemNavs"
              key={i}
              onClick={(e) => handleScrollView(item)}
            >
              {item}
            </div>
          ))}
          <a
            className="itemNavs githubNav"
            href="https://github.com/gauravsachar"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
        </div>
      </div>
    </Fragment>
  );
};

export default Header;
